<div class="loading-screen-icon" *ngIf="loading" data-cy="cyLoading">
  <ng-lottie [options]="options" width="65" height="65" [styles]="styles"></ng-lottie>
</div>
